import { defineStore } from 'pinia';
import { getProjectCreatingQuote } from '@/services/modules/project';
import { getWastesWithoutChild, getWastesByPath } from '@/services/modules/waste';
import type { GarbageLarge } from '@/views/RegisterLargeGarbage/const';
import { REGEX } from '@/constants';
import { getWastes } from '@/services/modules/master';

export const useProjectIndustryStore = defineStore({
  id: 'projectIndustry',
  state: () => ({
    project: {} as GarbageLarge,
    createStatus: false as boolean,
    confirmStatus: false as boolean,
    wasteIdSelected: [] as string[],
    wasteWithoutChild: [] as Object[],
    wastes: [] as any,
    todayListWastePrice: [] as any,
    wasteLevel0: [] as any
  }),
  getters: {
    getWasteIdSelected: (state) => {
      return state.wasteIdSelected ?? [];
    },
    getWasteWithoutChild: (state) => {
      return state.wasteWithoutChild;
    },
    getWastes(state) {
      return state.wastes;
    }
  },
  actions: {
    async checkCreatingQuoteExist() {
      this.createStatus = false;
      try {
        const response: any = await getProjectCreatingQuote('');
        const regex = REGEX.RESPONSE_20X;
        if (regex.test(response.status)) {
          this.createStatus = true;
        }
      } catch (e) {
        console.log('Not found creating quote');
      }
    },
    initProject(project: GarbageLarge) {
      this.project = project;
    },
    async fetchWastes() {
      const response: any = await getWastes(true);
      if (REGEX.RESPONSE_20X.test(response.status)) {
        this.wastes = response.data;
      }
    },
    async fetchWastesLevel0() {
      const response: any = await getWastesByPath('0');
      if (REGEX.RESPONSE_20X.test(response.status)) {
        this.wasteLevel0 = response.data;
      }
    },
    async fetchWasteWithoutChild() {
      const response: any = await getWastesWithoutChild();
      if (REGEX.RESPONSE_20X.test(response.status)) {
        this.wasteWithoutChild = response.data;
      }
    },

    removeWaste(index: number) {
      this.project.pwasteIndustries.splice(index, 1);
    },
    fetchWasteIdSelected(wasteIdSelected: any) {
      this.wasteIdSelected = wasteIdSelected;
    },
    getProjectInfo() {
      const mapWasteIndustry = (waste: any) => {
        const was: any = {
          dimensions: waste.dimensions,
          packing: {
            id: waste.packing.id ?? ''
          },
          quantity: waste.quantity.replace(',', ''),
          quantityUnit: waste.quantityUnit,
          frequency: waste.frequency,
          frequencyNumber: waste.frequencyNumber,
          measureUnit: waste.measureUnit,
          waste: {
            id: waste.waste.id
          },
          files: waste.files
        };

        if (waste.wasteId) {
          was.id = waste.wasteId;
        }

        return was;
      };

      const project: any = {
        projectTitle: this.project.projectTitle,
        office: this.project.office,
        discharges: this.project.discharges,
        type: this.project.type,
        // collectionArea: { id: this.project.collectionArea.id ?? '' },
        company: { id: this.project.company.id ?? '' },
        pwasteIndustries: this.project.pwasteIndustries.map(mapWasteIndustry)
      };

      if (this.project.projectStatus) {
        project.projectStatus = this.project.projectStatus;
      }
      if (this.project.id) {
        project.id = this.project.id;
      }
      if (this.project.createdBy) {
        project.createdBy = this.project.createdBy;
      }
      if (this.project.memo) {
        project.memo = this.project.memo;
      }
      if (this.project.createdDate) {
        project.createdDate = this.project.createdDate;
      }

      return project;
    },

    async getProjectCreatingQuote() {
      try {
        const response: any = await getProjectCreatingQuote('');
        const regex = REGEX.RESPONSE_20X;
        console.log(response);
        console.log(regex.test(response.status));
        if (regex.test(response.status)) {
          const data = response.data;
          const pwasteIndustries = data.pwasteIndustries;

          for (let i = 0; i < pwasteIndustries.length; i++) {
            if (pwasteIndustries[i].wasteDetails !== undefined) {
              const wasteDetais = pwasteIndustries[i].wasteDetails;
              for (let j = 0; j < wasteDetais.length; j++) {
                pwasteIndustries[i][`wasteIdL${j}`] = Number(wasteDetais[j].wasteId);
                pwasteIndustries[i][`wasteL${j}Array`] = wasteDetais[j].wasteArray;
                pwasteIndustries[i]['quantity'] = String(pwasteIndustries[i].quantity);
                pwasteIndustries[i]['wasteId'] = pwasteIndustries[i].id;
                pwasteIndustries[i]['transTime'] = pwasteIndustries[i].transTime;
                if (pwasteIndustries[i].packing !== null) {
                  pwasteIndustries[i]['packing'] = pwasteIndustries[i].packing;
                  pwasteIndustries[i]['packingId'] = pwasteIndustries[i].packing.id;
                } else {
                  pwasteIndustries[i]['packing'] = { id: '' };
                }
              }
            }
          }
          const garbageLarge: any = {
            id: data.id,
            projectID: data.id,
            office: data.office,
            discharges: data.discharges,
            projectTitle: data.projectTitle,
            projectStatus: data.projectStatus,
            pwasteIndustries: data.pwasteIndustries,
            type: data.type,
            createdBy: data.createdBy,
            memo: data.memo
          };
          console.log(garbageLarge);
          this.project = garbageLarge;
        }
      } catch (e) {
        console.log(e);
        console.log('Not found creating quote');
        return e;
      }
    },
    handleProjectIndustry(formData: GarbageLarge, data: any) {
      const pwasteIndustries = data.pwasteIndustries;
      for (let i = 0; i < pwasteIndustries.length; i++) {
        if (pwasteIndustries[i].wasteDetails !== undefined) {
          const wasteDetais = pwasteIndustries[i].wasteDetails;
          for (let j = 0; j < wasteDetais.length; j++) {
            pwasteIndustries[i][`wasteIdL${j}`] = Number(wasteDetais[j].wasteId);
          }
        }
      }
      formData.id = data.id;
      formData.projectTitle = data.projectTitle;
      formData.office = data.office;
      formData.discharges = data.discharges;
      formData.transportCompany = data.transportCompany;
      formData.company = data.company;
      formData.type = data.type;
      formData.pwasteIndustries = data.pwasteIndustries;
      formData.createdBy = data.createdBy;
      formData.memo = data.memo;
      formData.projectStatus = data.projectStatus;
      return formData;
    }
  }
});
